import { render, staticRenderFns } from "./HornorBuyGoodsDetails.vue?vue&type=template&id=2c3ffef6&scoped=true&"
import script from "./HornorBuyGoodsDetails.vue?vue&type=script&lang=js&"
export * from "./HornorBuyGoodsDetails.vue?vue&type=script&lang=js&"
import style0 from "./HornorBuyGoodsDetails.vue?vue&type=style&index=0&id=2c3ffef6&scoped=true&lang=css&"
import style1 from "./HornorBuyGoodsDetails.vue?vue&type=style&index=1&id=2c3ffef6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3ffef6",
  null
  
)

export default component.exports